import React from "react";
import "./Footer.css";
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import YouTubeIcon from '@material-ui/icons/YouTube';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import BusinessIcon from '@material-ui/icons/Business';
import EnhancedEncryptionIcon from '@material-ui/icons/EnhancedEncryption';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Paper from "@material-ui/core/Paper";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import { Grid } from "@material-ui/core";
import securepayment from "../images/securepayment.png"
import MenuBookIcon from '@material-ui/icons/MenuBook';

const useStyles = makeStyles((theme) => ({
    footer: {
        backgroundColor: "#002D55",
        padding: theme.spacing(5),
        color: "#FFFFFF",
        justify: "center",
    },
    paper: {
        padding: theme.spacing(5),
        backgroundColor: "#002D55",
        color: "#FFFFFF",
        width: "100%",
        marginBottom: 0,
    },
   
}));

function Copyright() {
    return (
      <Typography variant="body1" color="#FFFFFF" align="center">
        {'Copyright © '}
        <Link color="inherit">
        Virtus Physio | Your Virtual Physiotherapist 
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}<br />{'CVR: 12345678. Located in Copenhagen. Denmark, EU.'}
      </Typography>
    );
}

export default function Footer() {
    const classes = useStyles();
        
    return (
        <Paper className={classes.paper}>
            <Grid container direction="row" style={{width: "85%", justify: "center", marginLeft: "9%"}}>
                <Grid item xs={12} sm={12} md={6} lg={3} align="left" >
                  <Typography variant="h6" style={{marginRight: 40, marginLeft: 15, marginTop: 25}}>
                    Social media
                  </Typography>
                  <div >
                    <List>
                        <ListItem>
                          <ListItemAvatar>
                                <FacebookIcon />   
                          </ListItemAvatar>
                          <ListItemText primary="Facebook page" style={{marginRight: 10, marginLeft: 0}}/>
                        </ListItem>
                        <ListItem>
                            <ListItemAvatar>  
                                <TwitterIcon />
                            </ListItemAvatar>
                            <ListItemText primary="YouTube Channel" style={{marginRight: 10, marginLeft: 0}}/>
                        </ListItem>
                        <ListItem>
                            <ListItemAvatar>
                                <YouTubeIcon />   
                            </ListItemAvatar>
                            <ListItemText primary="Twitter" style={{marginRight: 10, marginLeft: 0}}/>
                        </ListItem>
                    </List>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={3} align="left" >
                  <Typography variant="h6" style={{marginRight: 40, marginLeft: 15, marginTop: 25}}>
                    Information
                  </Typography>
                  <div >
                    <List>
                       <ListItem>
                          <ListItemAvatar>
                                <FacebookIcon />   
                          </ListItemAvatar>
                          <ListItemText primary="Terms & Conditions" style={{marginRight: 10, marginLeft: 0}}/>
                        </ListItem>
                        <ListItem>
                            <ListItemAvatar>  
                                <TwitterIcon />
                            </ListItemAvatar>
                            <ListItemText primary="Privacy & data policy" style={{marginRight: 10, marginLeft: 0}}/>
                        </ListItem>
                        <ListItem>
                            <ListItemAvatar>  
                                <MenuBookIcon />
                            </ListItemAvatar>
                            <ListItemText primary="FAQ" style={{marginRight: 10, marginLeft: 0}}/>
                        </ListItem>
                    </List>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={3} align="left" >
                  <Typography variant="h6"  style={{marginRight: 40, marginLeft: 15, marginTop: 25}}>
                    Contact
                  </Typography>
                  <div >
                    <List>
                        <ListItem>
                            <ListItemAvatar>
                                <MailOutlineIcon />   
                            </ListItemAvatar>
                          <ListItemText primary="info@virtusphysio.com"  style={{marginRight: 10, marginLeft: 0}}/>
                        </ListItem>
                        <ListItem>
                            <ListItemAvatar>  
                                <BusinessIcon />
                            </ListItemAvatar>
                            <ListItemText primary="Located at Nærumgade 9 st.th., Copenhagen. Denmark, EU." style={{marginRight: 10, marginLeft: 0}}/>
                        </ListItem>
                    </List>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={3} align="left" >
                  <Typography variant="h6"  style={{marginRight: 40, marginLeft: 15, marginTop: 25}}>
                    Safety
                  </Typography>
                  <div >
                    <List>
                        <ListItem>
                            <ListItemAvatar>
                                <EnhancedEncryptionIcon />   
                            </ListItemAvatar>
                            <ListItemText primary="Approved medical device in the EU." style={{marginRight: 10, marginLeft: 0}}/>
                        </ListItem>
                    
                        <ListItem>
                            <ListItemAvatar>
                                <VerifiedUserIcon />   
                            </ListItemAvatar>
                            <ListItemText primary="Secure data with GDPR compliance, EU." style={{marginRight: 10, marginLeft: 0}}/>
                        </ListItem>

                        <ListItem>
                            <ListItemAvatar>
                                <VerifiedUserIcon />   
                            </ListItemAvatar>
                            <ListItemText primary="Complies with the EU AI act." style={{marginRight: 10, marginLeft: 0}}/>
                        </ListItem>
                    
                        <ListItem>
                            <ListItemAvatar style={{marginTop: -65}}>
                                <CreditCardIcon />
                            </ListItemAvatar>
                            <ListItemText style={{marginRight: 10, marginLeft: 0}}>Secure payment through: <br/> <img src={securepayment}></img></ListItemText>
                        </ListItem>
                    </List>
                  </div>
                </Grid>
            </Grid>
            <Grid container direction="column" xs={12} style={{marginTop: 30}}>
    
                    <div >
                        <Typography variant="subtitle1" component="p" gutterBottom>
                            <Copyright/>
                        </Typography>
                    </div>
                
            </Grid>
        </Paper>
    );
};

//export default Footer;

